import React from 'react';
import styles from './Modal.module.css';
import { FaTimes } from 'react-icons/fa';

function Modal({ children, onClose, className = '' }) {
    const handleOverlayClick = () => {
        onClose();
    };

    const handleContentClick = (e) => {
        e.stopPropagation();
    };

    const modalClasses = `${styles.modal} ${className}`;

    return (
        <div className={styles.modalBackdrop} onClick={handleOverlayClick}>
            <div className={modalClasses} onClick={handleContentClick}>
                <div className={"scrollContainer"}>
                    <button onClick={onClose} className={styles.closeModal}><FaTimes /></button>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;
